import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { PapSelector } from "../formComponents/formComponents";
import { useTranslation } from "react-i18next";
import UpdatingSpinner from "../ui/UpdatingSpinner";

import {
  idx_data_pitch,
  idx_data_pitch_32,
  idx_data_pitch_16p,
  idx_data_pitch_64,
  idx_data_pitch_32p,
  idx_data_pitch_left,
  idx_data_pitch_left_32,
  idx_data_pitch_left_16p,
  idx_data_pitch_left_64,
  idx_data_pitch_left_32p,
  idx_data_pitch_right,
  idx_data_pitch_right_32,
  idx_data_pitch_right_16p,
  idx_data_pitch_right_64,
  idx_data_pitch_right_32p,
  idx_data_insert_sizes,
  idx_data_insert_sizes_od,
  idx_data_insert_types,
  idx_data_clt,
  idx_data_span_measurement,
  idx_data_span_measurement_32,
  idx_data_span_measurement_16p,
  idx_data_span_measurement_64,
  idx_data_span_measurement_32p,
  idx_data_thumb_insert_sizes,
  idx_data_thumb_insert_types,
  idx_data_thumb_type,
  idx_data_flexibility,
  idx_data_hole_sizes,
  idx_data_angle,
  idx_data_angle_1,
  modal_data_titles,
  idx_data_pap_h,
  idx_data_pap_v,
} from "../db/datafixtures/datafixtures";
import {
  specsheetHandleForm,
  specsheetSVGClickOpen,
  specsheetSetOpenDropdown,
} from "../specsheet/specsheet.redux";
import { idx_data_grip, idx_data_hand } from "../settings/settings.sources";
import { getCustomer } from "../bowlers/bowlers.redux";

const lableStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};
const modalStyle = {
  borderBottom: "transparent",
  background: "#F0EDED",
};
const bodyStyle = {
  borderBottom: "transparent",
  background: "#F0EDED",
  padding: "0rem 1rem 1rem 1rem",
};
const formStyle = {
  display: "flex",
  flexWrap: "nowrap",
};

const doubleButtonStyle = {
  width: "30px",
  height: "100%",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const inputStyle = {
  width: "100%",
  height: "30px",
};
const colStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};

const temporalButton = {
  width: "auto",
  height: "auto",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "30%",
};

//oval calculation button start
const ButtonCalculateOvalStyle = {
  borderColor: "white",
  backgroundColor: "#20358c",
  fontSize: "18px",
  height: "3em",
  textTransform: "uppercase",
};

const ButtonCalculateOval = ({ className, children, onClick }) => (
  <Button
    type="primary"
    size="large"
    className={className}
    style={ButtonCalculateOvalStyle}
    onClick={onClick}
  >
    {children}
  </Button>
);
//oval calculation button end

const ModalRedux = (props) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState("Oval Width");

  const {
    initialValues,
    pitchDS,
    pitch_leftDS,
    pitch_rightDS,
    openDropdown,
    showModal,
    specsheetSVGClickOpen,
    span_measurementDS,
    spec_sheet_auto_insert_od,
    spec_sheet_auto_repeat_insert_type,
    spec_sheet_auto_repeat_insert_size,
    spec_sheet_auto_lateral_pitches_clt,
    spec_sheet_auto_lateral_pitches,
    spec_sheet_auto_thumb_pitches,
    specsheetHandleForm,
    specsheetSetOpenDropdown,
    isOval,
    isOvalCalculationVisible,
    angle_measurement,
    updatingValues,
    isEdit = false,
    state,
    pap_h,
    pap_v,
    pap_ud,
    specsheetName,
    initialCurrentSpecsheet,
  } = props;

  //Form Finger
  const pitchSelectDS = pitchDS.map((pitch) => ({
    text: pitch.fraction,
    value: pitch.fraction,
  }));
  const pitchLeftSelectDS = pitch_leftDS.map((pitch) => ({
    text: pitch.fraction,
    value: pitch.fraction,
  }));

  const pitchRightSelectDS = pitch_rightDS.map((pitch) => ({
    text: pitch.fraction,
    value: pitch.fraction,
  }));

  const idx_data_insert_typesDS = idx_data_insert_types.map((type) => ({
    text: type.type,
    value: type.type,
  }));

  const f1_grip_type = R.find(
    R.propEq("type", R.pathOr("", ["f1_grip_type"])(initialValues))
  )(idx_data_insert_types);

  const f1_idx_data_insert_sizesDS = R.pipe(
    R.filter(R.propEq("type_id", R.path(["id"])(f1_grip_type))),
    R.map((size) => ({
      text: size.size,
      value: size.size,
    }))
  )(idx_data_insert_sizes);

  const getInsertSizes = (gridType) =>
    R.pipe(R.filter(R.propEq("type_id", R.path(["id"])(gridType))));

  const f2_grip_type = R.find(
    R.propEq("type", R.pathOr("", ["f2_grip_type"])(initialValues))
  )(idx_data_insert_types);

  const f2_idx_data_insert_sizesDS = R.pipe(
    R.filter(R.propEq("type_id", R.path(["id"])(f2_grip_type))),
    R.map((size) => ({
      text: size.size,
      value: size.size,
    }))
  )(idx_data_insert_sizes);

  const idx_data_insert_sizes_od_DS = idx_data_insert_sizes_od.map((size) => ({
    text: size.size,
    value: size.size,
  }));

  const idx_data_clt_DS = idx_data_clt.map((clt) => ({
    text: clt.angle,
    value: clt.angle,
  }));
  //Form Ruler
  const span_measurementSelectDS = span_measurementDS.map((measure) => ({
    text: measure.fraction,
    value: measure.fraction,
  }));

  //Form Thumb
  const idx_data_thumb_insert_typesDS = idx_data_thumb_insert_types.map(
    (type) => ({
      text: type.type,
      value: type.type,
    })
  );

  const thm_insert_type = R.find(
    R.propEq("type", R.pathOr("", ["thm_insert_type"])(initialValues))
  )(idx_data_thumb_insert_types);

  const idx_data_hole_sizes_DS = idx_data_hole_sizes.map((size) => ({
    text: size.size,
    value: size.size,
  }));

  const thm_idx_data_insert_sizesDS = !thm_insert_type?.select_size
    ? R.pipe(
        R.filter(R.propEq("type_id", R.path(["id"])(thm_insert_type))),
        R.map((size) => ({
          text: size.size,
          value: size.size,
        }))
      )(idx_data_thumb_insert_sizes)
    : idx_data_hole_sizes_DS;

  const thm_idx_data_insert_sizes_od_DS = thm_insert_type?.select_od
    ? R.pipe(
        R.filter(R.propEq("type_id", R.path(["id"])(thm_insert_type))),
        R.map((size) => size.od),
        R.dropRepeats,
        R.map((od) => ({
          text: od,
          value: od,
        }))
      )(idx_data_thumb_insert_sizes)
    : [];

  const idx_data_thumb_type_DS = idx_data_thumb_type.map((type) => ({
    text: type.type,
    value: type.type,
  }));

  const idx_data_flexibility_DS = idx_data_flexibility.map((flexibility) => ({
    text: flexibility.flexibility,
    value: flexibility.flexibility,
  }));

  const idx_data_angle_DS =
    angle_measurement === "1"
      ? idx_data_angle_1.map((angle) => ({
          text: angle.angle,
          value: angle.angle,
        }))
      : idx_data_angle.map((angle) => ({
          text: angle.angle,
          value: angle.angle,
        }));

  // Pap v and h
  const idx_data_pap_h_DS = idx_data_pap_h.map((pap_h) => ({
    text: pap_h.pap_h,
    value: pap_h.pap_h,
  }));
  const idx_data_pap_v_DS = idx_data_pap_v.map((pap_v) => ({
    text: pap_v.pap_v,
    value: pap_v.pap_v,
  }));

  useEffect(() => {
    if (openDropdown) {
      const getTitle = modal_data_titles.find(
        (element) => element.name === openDropdown
      );
      if (getTitle?.textLabel) {
        setTitle(getTitle.textLabel);
      } else {
        setTitle(getTitle?.selectorLabel);
      }
    }
  }, [openDropdown]);

  const handleClose = () => specsheetSetOpenDropdown({ openDropdown: "" });

  const change = (field, value) => {
    if (typeof field === "object") {
      const values = { ...initialValues };
      const result = R.mergeAll([values, field]);
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(result);
      specsheetHandleForm({ specsheetValues: processedValues });
    } else {
      const values = { ...initialValues };
      values[field] = value;
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(values);

      specsheetHandleForm({
        specsheetValues: processedValues,
        noCloseDropdown: field === "name",
      });
    }
  };

  // General handle Form
  const openHandler = {
    values: initialValues,
    openDropdown,
    onDropdownVisibleChange: () => specsheetSVGClickOpen(),
    onChange: change,
  };

  const renderSwitch = (openDropdown) => {
    switch (openDropdown) {
      case "pap":
        let temp = { pap_h: pap_h, pap_v: pap_v };
        return (
          <>
            <PapSelector
              values={temp}
              name={"pap_h"}
              source={idx_data_pap_h_DS}
              label={"H:"}
              {...openHandler}
            />
            <PapSelector
              {...openHandler}
              values={temp}
              name={"pap_v"}
              source={idx_data_pap_v_DS}
              label={"V:"}
            />
            <ButtonGroup>
              <Button
                active={pap_ud === "Up" ? true : false}
                name="pap_ud"
                value="Up"
                onClick={() => change("pap_ud", "Up")}
              >
                ▲
              </Button>
              <Button
                active={pap_ud !== "Up" && pap_ud !== "Down" ? true : false}
                name="pap_ud"
                value=""
                onClick={() => change("pap_ud", "Up")}
              >
                -
              </Button>
              <Button
                active={pap_ud === "Down" ? true : false}
                name="pap_ud"
                value="Down"
                onClick={() => change("pap_ud", "Up")}
              >
                ▼
              </Button>
            </ButtonGroup>
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <Modal size="sm" show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton style={modalStyle}>
          <span style={lableStyle}>{t(`form.label.${title}`)}</span>
        </Modal.Header>
        {updatingValues && openDropdown !== "name" ? (
          <Modal.Body style={bodyStyle}>
            <UpdatingSpinner />
          </Modal.Body>
        ) : isEdit ? (
          <Modal.Body style={bodyStyle}>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
                style={formStyle}
              >
                <div className="row">
                  <div className="col-10">
                    <div className="row">
                      <div className="col-2" style={colStyle}>
                        <Form.Label>V: </Form.Label>
                      </div>
                      <div className="col-10">
                        <Form.Control
                          type="text"
                          placeholder="v"
                          autoFocus
                          style={inputStyle}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-2" style={colStyle}>
                        <Form.Label>H: </Form.Label>
                      </div>
                      <div className="col-10">
                        <Form.Control
                          type="text"
                          placeholder="h"
                          autoFocus
                          style={inputStyle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <Button onClick={handleClose} style={doubleButtonStyle}>
                      <FontAwesomeIcon icon={["fas", "arrow-down"]} />
                    </Button>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
        ) : (
          <Modal.Body style={bodyStyle}>
            {renderSwitch(openDropdown)}
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export const ModalBowlers = connect(
  (state) => {
    const pitch_measurement =
      state.settings.appSettings.systemDefault.pitch_measurement;
    const span_measurement =
      state.settings.appSettings.systemDefault.span_measurement;

    const span_measurementDS = {
      32: idx_data_span_measurement_32,
      "16+": idx_data_span_measurement_16p,
      64: idx_data_span_measurement_64,
      "32+": idx_data_span_measurement_32p,
    };

    const pitchDS = R.pathOr(idx_data_pitch, [pitch_measurement])({
      32: idx_data_pitch_32,
      "16+": idx_data_pitch_16p,
      64: idx_data_pitch_64,
      "32+": idx_data_pitch_32p,
    });

    const pitch_leftDS = R.pathOr(idx_data_pitch_left, [pitch_measurement])({
      32: idx_data_pitch_left_32,
      "16+": idx_data_pitch_left_16p,
      64: idx_data_pitch_left_64,
      "32+": idx_data_pitch_left_32p,
    });

    const pitch_rightDS = R.pathOr(idx_data_pitch_right, [pitch_measurement])({
      32: idx_data_pitch_right_32,
      "16+": idx_data_pitch_right_16p,
      64: idx_data_pitch_right_64,
      "32+": idx_data_pitch_right_32p,
    });

    const omitEmptyFields = (val) => val !== "";
    const initialValues = R.pipe(
      R.pickBy(omitEmptyFields),
      R.omit(["updated_at", "created_at"])
    )(state.specsheet.currentSpecSheet);
    const isOval = R.path(["thm_type"])(initialValues) === "Oval";

    return {
      initialValues,
      enableReinitialize: true,
      spec_sheet_auto_insert_od:
        state.settings.appSettings.autoSuggestions.spec_sheet_auto_insert_od,
      spec_sheet_auto_repeat_insert_type:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_repeat_insert_type,
      spec_sheet_auto_repeat_insert_size:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_repeat_insert_size,
      spec_sheet_auto_lateral_pitches_clt:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_lateral_pitches_clt,
      pitchDS,
      pitch_leftDS,
      pitch_rightDS,
      openDropdown: state.specsheet.openDropdown,
      showModal: state.specsheet.openDropdown !== "",
      state: state,
      span_measurementDS: R.pathOr(idx_data_span_measurement, [
        span_measurement,
      ])(span_measurementDS),
      spec_sheet_auto_thumb_pitches:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_thumb_pitches,
      spec_sheet_auto_lateral_pitches:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_lateral_pitches,
      //form thumb
      isOvalCalculationVisible:
        isOval &&
        state.settings.appSettings.thumbHolePreferences.oval_calculation !==
          "manual",
      isOval,
      angle_measurement:
        state.settings.appSettings.systemDefault.angle_measurement,
      updatingValues: state.specsheet.updatingValues,
      pap_v: state.bowlers.selectedCustomer.pap_v,
      pap_h: state.bowlers.selectedCustomer.pap_h,
      specsheetName: state.specsheet.currentSpecSheet?.name || "",
      initialCurrentSpecsheet: state.specsheet.currentSpecSheet,
    };
  },
  { specsheetHandleForm, specsheetSVGClickOpen, specsheetSetOpenDropdown }
)(ModalRedux);
